import React, { FC } from 'react';
import { CurrentCycleContent } from '../../../common/model/dto/current-cycle-content';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';
import OvButton from '../atoms/OvButton';
import OvListTableField from '../atoms/OvListTableField';
import { NavLink } from 'react-router-dom';
import OvListTableButtonField from '../atoms/OvListTableButtonField';
import { useTranslation } from 'react-i18next';
import DateUtils from '../../../common/utils/services/date-utils';
import { CurrentCycleContentDataUtils } from '../../../common/utils/services/current-cycle-content-data-utils';
import { Constants } from '../../../common/constants';

interface OvCurrentCycleContentListRowProps {
  currentCycleContent: CurrentCycleContent;
}

const OvCurrentCycleContentListRow: FC<OvCurrentCycleContentListRowProps> = ({
  currentCycleContent,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <OvListTableField>{currentCycleContent.current_phase}</OvListTableField>
      <OvListTableField>
        {CurrentCycleContentDataUtils.getAgeRange(currentCycleContent)}
      </OvListTableField>
      <OvListTableField>{currentCycleContent.health_goal}</OvListTableField>
      <OvListTableField>
        {currentCycleContent.created_at
          ? DateUtils.formatDate(
              currentCycleContent.created_at as unknown as Date,
              Constants.US_DATE_DISPLAY_FORMAT_WITHOUT_TIME
            )
          : '-'}
      </OvListTableField>
      <OvListTableField>
        {currentCycleContent.updated_at
          ? DateUtils.formatDate(
              currentCycleContent.updated_at as unknown as Date,
              Constants.US_DATE_DISPLAY_FORMAT_WITHOUT_TIME
            )
          : '-'}
      </OvListTableField>
      <OvListTableButtonField>
        <StyledOvButton>
          <NavLink to={`/current-cycle-contents/${currentCycleContent.id}`}>
            {t('common.actions.seeDetails')}
          </NavLink>
        </StyledOvButton>
      </OvListTableButtonField>
    </>
  );
};

export default OvCurrentCycleContentListRow;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    padding: 0;
    margin: 0;
    background-color: ${Colours.OV_BASE};

    &:hover {
      a {
        color: ${Colours.OV_BASE};
      }
    }

    a {
      border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
      padding: 0.25rem 1rem;
      text-decoration: none;
      text-transform: none;
      font-weight: bold;
      font-size: 0.75rem;
      color: ${Colours.OV_WHITE};
    }
  }
`;
